import { render, staticRenderFns } from "./Berita.vue?vue&type=template&id=f8acd5fa&scoped=true"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"
import style0 from "./Berita.vue?vue&type=style&index=0&id=f8acd5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8acd5fa",
  null
  
)

export default component.exports